import React from 'react';

/** Small native map showing a collection route and the truck position. */
export function TruckRouteMap() {
  return <svg viewBox="0 0 120 80" className="w-[112px] h-[76px] shrink-0 rounded-lg border border-[#EDEEF3]" aria-hidden="true" data-id="element-1984" data-mp="1qomlzy2ni48t">
      <rect width="120" height="80" fill="#F3F4F1" data-id="element-1985" data-mp="20fqzsuglbj22" />
      <rect x="6" y="8" width="30" height="20" rx="2" fill="#E9EBE4" data-id="element-1986" data-mp="20efma2xcewxr" />
      <rect x="44" y="4" width="26" height="16" rx="2" fill="#E9EBE4" data-id="element-1987" data-mp="13pzs1tjafzeb" />
      <rect x="78" y="42" width="34" height="26" rx="2" fill="#E9EBE4" data-id="element-1988" data-mp="17r39gkgzi3hn" />
      <rect x="8" y="52" width="24" height="22" rx="2" fill="#E6EDE3" data-id="element-1989" data-mp="17rczg8214anc" />
      <path d="M0 38 H120 M58 0 V80 M0 66 L120 18" stroke="#FFFFFF" strokeWidth="4" data-id="element-1990" data-mp="1cp4psxn0zopf" />
      <path d="M16 74 C 26 56, 44 48, 60 46 C 78 44, 88 30, 100 22" stroke="#4F46E5" strokeWidth="2.6" fill="none" strokeLinecap="round" data-id="element-1991" data-mp="1hpj06mc3naqm" />
      <circle cx="16" cy="74" r="3" fill="#FFFFFF" stroke="#4F46E5" strokeWidth="1.6" data-id="element-1992" data-mp="2t3wlpkjdre3h" />
      <circle cx="100" cy="21" r="8.5" fill="#FFFFFF" stroke="#4F46E5" strokeWidth="1.6" data-id="element-1993" data-mp="1uy4kfh13qii2" />
      <rect x="94.5" y="17.5" width="7" height="6" rx="1" fill="#4F46E5" data-id="element-1994" data-mp="1qwj9w2c1igb1" />
      <path d="M101.5 19.5 H104 L105.5 21.5 V23.5 H101.5 Z" fill="#4F46E5" data-id="element-1995" data-mp="1qxar284w4bhs" />
      <circle cx="96.5" cy="24.5" r="1.1" fill="#4F46E5" data-id="element-1996" data-mp="1lw4ycab8co89" />
      <circle cx="103.5" cy="24.5" r="1.1" fill="#4F46E5" data-id="element-1997" data-mp="1gylkhbig2dgu" />
    </svg>;
}
function Pin({
  x,
  y
}: {
  x: number;
  y: number;
}) {
  return <g transform={`translate(${x} ${y})`} data-id="element-1998" data-mp="1c01xd7s46vmw">
      <path d="M0 -11 C -5 -11, -7 -7, -7 -4.5 C -7 0, 0 6, 0 6 C 0 6, 7 0, 7 -4.5 C 7 -7, 5 -11, 0 -11 Z" fill="#4F46E5" opacity="0.9" data-id="element-1999" data-mp="1c1381b57xg43" />
      <circle cx="0" cy="-5" r="2.2" fill="#FFFFFF" data-id="element-2000" data-mp="137gl8aiznn71" />
    </g>;
}

/** Small native map with several nearby drop-off pins. */
export function DropOffMap() {
  return <svg viewBox="0 0 120 80" className="w-[112px] h-[76px] shrink-0 rounded-lg border border-[#EDEEF3]" aria-hidden="true" data-id="element-2001" data-mp="t90sy48867vy">
      <rect width="120" height="80" fill="#F3F4F1" data-id="element-2002" data-mp="obr16hxd5k4y" />
      <rect x="4" y="44" width="36" height="30" rx="2" fill="#E6EDE3" data-id="element-2003" data-mp="el0o3y4vqewc" />
      <rect x="70" y="6" width="44" height="22" rx="2" fill="#E9EBE4" data-id="element-2004" data-mp="jkvhq9g1hil3" />
      <rect x="50" y="50" width="26" height="24" rx="2" fill="#E9EBE4" data-id="element-2005" data-mp="jj2aarxlquc1" />
      <path d="M0 32 H120 M44 0 V80 M86 0 V80 M0 12 L50 80" stroke="#FFFFFF" strokeWidth="4" data-id="element-2006" data-mp="5myg2ymqalzk" />
      <Pin x={30} y={40} data-id="element-2007" data-mp="9nqu056jpf26" />
      <Pin x={62} y={22} data-id="element-2008" data-mp="9p1wm1o98grp" />
      <Pin x={96} y={44} data-id="element-2009" data-mp="xctju0bc2e7r" />
      <Pin x={74} y={66} data-id="element-2010" data-mp="xdl1s8c0cdfk" />
    </svg>;
}

/** Compact voice waveform. */
export function VoiceWave() {
  const bars = [6, 12, 8, 18, 10, 22, 14, 8, 16, 10, 6, 12, 7];
  return <div className="w-[78px] h-[54px] shrink-0 rounded-lg border border-[#EDEEF3] bg-[#FAFAFC] flex items-center justify-center gap-[3px]" aria-hidden="true" data-id="element-2011" data-mp="okrky6gwx5zl">
      {bars.map((h, i) => <span key={i} className="w-[2px] rounded-full bg-[#4F46E5]" style={{
      height: `${h}px`,
      opacity: i % 3 === 0 ? 0.55 : 0.9
    }} data-id="element-2012" data-mp="1gaw4k2wulozr" data-mpi={i} />)}
    </div>;
}

/** Compact email inbox preview. */
export function InboxPreview() {
  return <div className="w-[78px] h-[54px] shrink-0 rounded-lg border border-[#EDEEF3] bg-white px-2 py-1.5 flex flex-col justify-center gap-1.5" aria-hidden="true" data-id="element-2013" data-mp="30tga7946j42e">
      {[0, 1, 2].map(i => <span key={i} className="flex items-center gap-1.5" data-id="element-2014" data-mp="3ajjaludmrkar">
          <span className="w-2 h-2 rounded-full bg-[#E0DFF8]" data-id="element-2015" data-mp="3alcmpp70iwq5" />
          <span className="h-[3px] rounded-full bg-[#D9DAE5]" style={{
        width: `${40 - i * 8}px`
      }} data-id="element-2016" data-mp="2muqd3thd14e1" />
        </span>)}
    </div>;
}